import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import * as Chart from 'chart.js';
import 'chartjs-plugin-datalabels';
import * as _ from 'lodash';

@Component({
    selector: 'chart-pie-component',
    templateUrl: 'chart-pie-component.html',
    styleUrls: ['./chart-pie-component.scss']
})

export class ChartPieComponent implements OnInit, AfterViewInit {

    @ViewChild('pieChart', {static: false}) pieChart;

    @Input() titulo: string;
    @Input() classCSS: string;
    @Input() lista: any = [];

    chart: any;

    constructor() {
    }

    ngOnInit() {
        console.log('ngAfterViewInit -> ChartPieComponent');
    }

    ngAfterViewInit() {
        this.createPieChart();
    }

    createPieChart() {
        const option = {
            responsive: true,
            cutoutPercentage: 65,
            maintainAspectRatio: false,
            title: {
                display: false,
            },
            legend: {
                display: false,
            },
            tooltips: {
                enabled: false,
                backgroundColor: '#000',
                titleFontSize: 14,
                titleFontColor: '#FFFFFF',
                bodyFontColor: '#FFFFFF',
                bodyFontSize: 13,
            }
        };

        const data = {
            labels: _.map(this.lista, 'nome'),
            datasets: [{
                datalabels: {
                    display: false,
                },
                backgroundColor: _.map(this.lista, 'color'),
                data: _.map(this.lista, 'qtd')
            }]
        };

        this.chart = new Chart(this.pieChart.nativeElement, {
            type: 'doughnut',
            data,
            options: option
        });
    }
}
